import React from 'react'

export const Balloon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='30'
    height='30'
    viewBox='0 0 20 20'
    {...props}
  >
    <g clip-path="url(#clip0_5968_77327)">
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M4 10.5C4 5.87168 7.51786 2 12 2C16.4821 2 20 5.87168 20 10.5C20 14.778 16.9945 18.4096 13 18.9348V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18.9348C7.00552 18.4096 4 14.778 4 10.5ZM12 17C12.3396 17 12.6738 16.9689 13 16.9091V14.3204L15.3137 11.0812C15.6347 10.6318 15.5307 10.0072 15.0812 9.68622C14.6318 9.36521 14.0073 9.46931 13.6863 9.91872L11.8724 12.4581L10.7071 11.2928C10.3166 10.9023 9.68342 10.9023 9.29289 11.2928C8.90237 11.6834 8.90237 12.3165 9.29289 12.7071L11 14.4142V16.9091C11.3262 16.9689 11.6604 17 12 17Z"/>
    </g>
    <defs>
      <clipPath id="clip0_5968_77327">
        <rect width="30" height="30" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
